<template>
    <div class="invites">
        <BAlert variant="info"
                 dismissible
                 :show="showDismissibleAlert"
                 @dismissed="alertMessage = null">
            {{alertMessage}}
        </BAlert>

        <BTable striped hover
            stacked="md"
            :items="invites"
            :fields="inviteFields"
        >
            <template v-slot:cell(invited_at)="{item}">
                {{ formatDate(item.effective_invite_date) }}
            </template>
            <template v-slot:cell(accepted_at)="{item}">
                {{ formatDate(item.accepted_at) }}
            </template>
            <template v-slot:cell(last_resent_at)="{item}">
                {{ formatDate(item.last_resent_at) }}
            </template>
            <template v-slot:cell(actions)="row">
                <BButton size="sm" variant="primary" v-if="!row.item.registered" :disabled="!registrationCode.is_valid" @click="resendInvite(row.item)" class="mr-1">
                    Resend Invite
                </BButton>
            </template>                    
        </BTable>
        <BRow v-if="invites.length < 1" class="mt-2 ml-3">
            <BCol>
                <h5>{{emptyMessage}}</h5>
            </BCol>
        </BRow>
    </div>
</template>

<style>
.alert-dismissible {
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
}
.alert-dismissible .close {
    padding-top: 9px !important;
    font-size: 30px !important;
    font-weight: bold !important;
}
</style>

<script>
    import moment from 'moment';

    export default {
        props: {
            'registration-code': {
                type: Object,
                required: true
            }, 
            'refresh-invites': {
                required: true
            }
        },
        data() {
            return {
                testModal: false,
                invites: [],
                loading: false,
                inviteFields: [
                    { 
                        key: 'to_name', 
                        label: 'Name', 
                        sortable: true, 
                        thStyle: {
                            width: '20%'
                        }
                    },
                    { 
                        key: 'to_email', 
                        label: 'Email', 
                        sortable: true
                    },
                    { 
                        key: 'invited_at', 
                        label: 'Invited', 
                        sortable: true, 
                        class: 'invited-date' 
                    },
                    { 
                        key: 'accepted_at', 
                        label: 'Registered', 
                        sortable: true, 
                        class: 'registered-date' 
                    },
                    { 
                        key: 'actions', 
                        label: 'Actions', 
                        class: 'resend-button' 
                    },
                ],
                invitesModal: false,
                alertMessage: null,
                invite: {},
                createInviteModal: false,
                previewInviteModal: false,
                recipient_options: [
                    { text: 'Program User', value: 'program-user' },
                    { text: 'TA Consultant', value: 'ta-consultant' },
                    { text: 'Partner User', value: 'partner-user' }
                ],
                filter: null,
                showDismissibleAlert: false
            }
        },
        watch: {
            registrationCode(to, from) {
                if (to === null) {
                    this.invites = [];
                } else if (to.code) {
                    this.getInvites();
                }
            },
            refreshInvites: function() {
                this.getInvites();
            }
        },
        computed: {
            emptyMessage: function() {
                return (this.loading) ? 'Loading...' : 'No invites exist for this code';
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            }
        },
        methods: {
            getInvites() {
                var config = {  headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache'}};
                this.loading = true;
                if (this.registrationCode.code !== undefined)
                    axios.get('/api/invites?code='+ this.registrationCode.code, config)
                    .then((response) => {
                        this.invites = response.data.data
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.error(error)
                        this.loading = false;
                    })
            },
            openCreateInvite() {
                this.$emit(
                    'openCreateInvite', 
                    { 
                        registrationCode: this.registrationCode 
                    }
                );
            },
            resendInvite(item) {
                this.showDismissibleAlert = false
                item.last_resent_at = moment().format('YYYY-MM-DD hh:mm:ss');
                axios.put('/api/invites/'+item.id, item)
                    .then(response => {
                        this.alertMessage = 'Invite resent successfully';
                        this.showDismissibleAlert = true;
                        this.getInvites();
                    })
                    .catch(error => {
                        console.error(error)
                    })
            }
        },
        mounted() {
            this.getInvites();
        }
    }

</script>